export const BASEURL = `https://cinemacity-demo-api.nuviotech.co`;
//export const SOCKETURL = BASEURL;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://novoimages.nuviotech.co/`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;



// WEBPACK FOOTER //
// ./src/config/index.js